export default __webpack_public_path__ + "31778ed9e56a588e615bc105f507082d.svg";